import { render } from "./FinanceBody.vue?vue&type=template&id=72ab001e&scoped=true"
import script from "./FinanceBody.vue?vue&type=script&lang=js"
export * from "./FinanceBody.vue?vue&type=script&lang=js"

import "./FinanceBody.vue?vue&type=style&index=0&id=72ab001e&scoped=true&lang=css"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ab001e"]])

export default __exports__